export default "__VITE_ASSET__DQ0JETQm__"